import {pick} from 'lodash';
import React from 'react';

import {AllColumns, ApiForecastTimeSeries, ForecastTime} from 'src/lib/api/series';
import {Dims} from 'src/lib/commonTypes';

import {XScale, YScale} from './D3Axis';
import {MouseDateState} from './Tooltip';
import {VizConfigItem} from './Viz/config';

type Props = {
  x: XScale;
  y: YScale;
  graphDims: Dims;
  forecastTimeSeriesList: ApiForecastTimeSeries[];
  column: AllColumns;
  getStyle: VizConfigItem['getStyle'];
  focusedForecastTime: ForecastTime | null;
  setFocusedForecastTime: (forecastTime: ForecastTime | null) => void;
  timeZone: string;
  startDate: Date;
  setMouseDate: MouseDateState['setMouseDate'];
};

export default function IssueTimeMarkers({
  x,
  y,
  graphDims,
  forecastTimeSeriesList,
  column,
  getStyle,
  focusedForecastTime,
  setFocusedForecastTime,
  timeZone,
  startDate,
  setMouseDate,
}: Props) {
  return (
    <g>
      {forecastTimeSeriesList.flatMap((ts, i) => {
        return ts.forecasts
          .filter((f) => f.validTimes.length)
          .flatMap((f, j, arr) => {
            const firstValidTime = f.validTimes[0];
            const firstValue = f.data[column][0];

            if (firstValue == null || firstValidTime < startDate) {
              return null;
            }
            const style = pick(getStyle(j, arr.length), ['stroke', 'fill']);

            return (
              <g key={`${i}_${j}`}>
                <circle
                  cx={x(firstValidTime)}
                  cy={y(firstValue)}
                  r={3}
                  {...({
                    stroke: style.stroke,
                    fill: style.fill || 'transparent',
                  } as React.SVGProps<SVGCircleElement>)}
                />
                {/* This is just a larger hit target for the above */}
                <circle
                  className="cursor-pointer pointer-events-auto"
                  cx={x(firstValidTime)}
                  cy={y(firstValue)}
                  fill="transparent"
                  r={8}
                  onMouseEnter={() => {
                    setMouseDate(firstValidTime);
                    setFocusedForecastTime({
                      initializationTime: f.initializationTime,
                      issueTime: f.issueTime,
                    });
                  }}
                  onMouseLeave={() => {
                    setFocusedForecastTime(null);
                  }}
                />
              </g>
            );
          });
      })}
    </g>
  );
}
